"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Menu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _Context = require("../Context");
var _constants = require("../../constants");
var actions = _interopRequireWildcard(require("../../actions"));
var _appconfig = require("../../selectors/appconfig");
var _menu = require("../../selectors/menu");
var _MenuHeader = _interopRequireDefault(require("./MenuHeader"));
var _Logo = _interopRequireDefault(require("./Logo"));
var _ExpandableMenuGroup = _interopRequireDefault(require("./ExpandableMenuGroup"));
var _MenuGroup = _interopRequireDefault(require("./MenuGroup"));
var _styles = require("./styles");
var _menu2 = require("../../utils/menu");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Menu = exports.Menu = (0, _react.memo)(({
  activeNodePath,
  hiddenMenu = false,
  history
}) => {
  const activeSolution = (activeNodePath === null || activeNodePath === void 0 ? void 0 : activeNodePath[0]) || {};
  const menuBodyRef = (0, _react.useRef)(null);
  const locale = (0, _react.useContext)(_Context.LocaleContext);
  const appconfig = (0, _Context.useSelector)(_appconfig.getAppconfig);
  const theme = (0, _styledComponents.useTheme)();
  const solutions = (0, _Context.useSelector)(_menu.getSolutions);
  const solutionsVisibleL1 = (0, _menu2.getVisibleMenuNodes)(solutions);
  const isMenuExpanded = (0, _Context.useSelector)(_menu.isExpanded);
  const dispatch = (0, _Context.useDispatch)();
  const toggleCollapsed = expanded => {
    dispatch(actions.toggleMenu(expanded));
  };
  const Group = appconfig.expandableMenu ? _ExpandableMenuGroup.default : _MenuGroup.default;
  const constructMenu = (nodes, level = 2) => nodes.map(node => {
    var _activeNodePath;
    return _react.default.createElement(Group, {
      key: node.id,
      node: node,
      level: level,
      isActive: node.uri === (activeNodePath === null || activeNodePath === void 0 ? void 0 : (_activeNodePath = activeNodePath[level - 1]) === null || _activeNodePath === void 0 ? void 0 : _activeNodePath.uri),
      isExpanded: isMenuExpanded,
      history: history,
      sectionsView: level === 2 && (appconfig === null || appconfig === void 0 ? void 0 : appconfig.menuL3AsSection),
      menuRef: menuBodyRef,
      activeNodePathLength: activeNodePath.length
    }, (children, lvl) => constructMenu(children || [], lvl + 1));
  });
  const menuNodes = (appconfig.headerBasedSitemap ? solutionsVisibleL1 : activeSolution.children) ?? [];
  return _react.default.createElement(_styles.MenuContainer, {
    hasHeader: appconfig.header,
    hiddenMenu: hiddenMenu,
    collapsed: !isMenuExpanded
  }, theme.name !== _constants.THEMES.mds && _react.default.createElement(_MenuHeader.default, {
    toggleCollapsed: toggleCollapsed,
    isExpanded: isMenuExpanded,
    solutions: solutionsVisibleL1,
    switchLabel: locale.switchLabel,
    activeSolution: activeSolution,
    history: history
  }), _react.default.createElement(_styles.MenuBodyContainerWrapper, null, _react.default.createElement(_styles.MenuBodyContainer, {
    ref: menuBodyRef
  }, _react.default.createElement(_styles.MenuBody, null, menuNodes.length > 0 && constructMenu(menuNodes)))), theme.name !== _constants.THEMES.mds && _react.default.createElement(_styles.MenuFooter, null, _react.default.createElement(_styles.MenuFooterInner, null, _react.default.createElement(_styles.MenuFooterLogo, {
    collapsed: !isMenuExpanded
  }, _react.default.createElement(_Logo.default, {
    logo: appconfig.logo
  })))));
});
var _default = exports.default = Menu;